module.exports = __webpack_public_path__ + "static/desktop/img/templates-1.b51a9970.png";